module.exports = __webpack_public_path__ + "static/media/hear_results_3_mobile.d929a129.jpg";